<template>
  <div class="outter-modal">
    <div class="modal fade show" :class="{ 'modal-body-scroll': scrollBody }" :style="modalStyle" tabindex="-1">
      <div :class="modalClasses">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <slot name="header">
                {{ ' ' }}
              </slot>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" @click="$emit('close')">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
export default {
  name: 'ModalDialog',
  props: {
    msize: {
      type: String,
      default: 'modal-xl',
    },
    scrollBody: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalClasses() {
      return 'modal-dialog modal-dialog-centered ' + this.msize;
    },
    modalStyle() {
      return {
        display: 'block',
        overflow: this.scrollBody ? 'hidden' : 'scroll',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal {
  position: absolute;
  z-index: 1089;
}

.modal-dialog.modal-xxl {
  width: calc(100vw - 120px);
  max-width: 1250px;
}

@media (max-width: 767.98px) {
  .modal-dialog.modal-xxl {
    width: calc(100vw - 30px);
  }
}

.modal-body-scroll .modal-dialog {
  height: calc(100vh - 48px);
  margin-top: 24px;
  margin-bottom: 24px;
}

.modal-body-scroll .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-body-scroll .modal-body {
  overflow-y: auto;
}
</style>
